import { ContentfulEntryType } from './contentful-entry.type';

export class CompleteType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get headline(): string {
    return this.fields['headline'];
  }

  public get copy(): string {
    return this.fields['copy'];
  }

  public get persistenceButtonText(): string {
    return this.fields['persistenceButtonText'];
  }

  public get completeButtonText(): string {
    return this.fields['completeButtonText'];
  }

}


